import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useState, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import screens from '../../../screens';
import QueryParamProxy from '../../../utils/queryParamProxy';
import { MISSIONS_TYPES } from '../constants';
import { generateTabs } from '../utils/generateMissionRendering';
import { shouldShowTooltip, tooltipDetails } from '../../../state/actions/tooltip';
import { TabsCountDownTooltipDetail, TabsTooltipDetail } from '../tooltips';
var TOOLTIP_DURATION = 2000;
var useMissionsTabs = function useMissionsTabs(_ref) {
  var props = _ref.props,
    missionTabRef = _ref.missionTabRef;
  var navigation = props.navigation,
    currentMissionType = props.currentMissionType,
    battlesStarted = props.battlesStarted,
    _props$isOnMissions = props.isOnMissions,
    isOnMissions = _props$isOnMissions === void 0 ? false : _props$isOnMissions,
    _props$isOnBattles = props.isOnBattles,
    isOnBattles = _props$isOnBattles === void 0 ? false : _props$isOnBattles,
    _props$isPlayerJoinin = props.isPlayerJoining,
    isPlayerJoining = _props$isPlayerJoinin === void 0 ? true : _props$isPlayerJoinin,
    _props$battlesTimesta = props.battlesTimestamp,
    battlesTimestamp = _props$battlesTimesta === void 0 ? null : _props$battlesTimesta;
  var dispatch = useDispatch();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showClockIcon = _useState2[0],
    setShowClockIcon = _useState2[1];
  var rawBattlesAssets = useSelector(function (state) {
    return state.assetsPackage.assets.BATTLES_FEATURE;
  }, shallowEqual);
  var rawMissionsAssets = useSelector(function (state) {
    return state.assetsPackage.assets.MISSIONS_FEATURE;
  }, shallowEqual);
  var battlesAssets = useMemo(function () {
    return rawBattlesAssets || {};
  }, [rawBattlesAssets]);
  var missionsAssets = useMemo(function () {
    return rawMissionsAssets || {};
  }, [rawMissionsAssets]);
  var selectedTab = useMemo(function () {
    return generateTabs({
      battlesAssets: battlesAssets,
      currentMissionType: currentMissionType,
      isOnMissions: isOnMissions,
      isOnBattles: isOnBattles
    });
  }, [battlesAssets, currentMissionType, isOnMissions, isOnBattles]);
  var triggerTooltip = useCallback(function (type) {
    var _missionTabRef$curren;
    var detail = TabsTooltipDetail(battlesAssets.BATTLES_TOOLTIP, type, missionTabRef === null || missionTabRef === void 0 || (_missionTabRef$curren = missionTabRef.current) === null || _missionTabRef$curren === void 0 ? void 0 : _missionTabRef$curren[type]);
    dispatch(tooltipDetails(detail));
    dispatch(shouldShowTooltip(true));
    setTimeout(function () {
      dispatch(shouldShowTooltip(false));
    }, TOOLTIP_DURATION);
  }, [battlesAssets, dispatch, missionTabRef]);
  var handleOnPress = useCallback(function (type) {
    if (currentMissionType && currentMissionType !== type) triggerTooltip(type);else {
      var navigateTo = type === MISSIONS_TYPES.EXPLORER ? screens.Missions : screens.Battles;
      QueryParamProxy.navigate(navigation, navigateTo);
    }
  }, [currentMissionType, navigation, triggerTooltip]);
  useEffect(function () {
    var _missionTabRef$curren2;
    if (!battlesStarted || !isPlayerJoining || !battlesTimestamp) return;
    var detail = TabsCountDownTooltipDetail(battlesAssets.BATTLES_TOOLTIP, missionTabRef === null || missionTabRef === void 0 || (_missionTabRef$curren2 = missionTabRef.current) === null || _missionTabRef$curren2 === void 0 ? void 0 : _missionTabRef$curren2[MISSIONS_TYPES.BATTLES]);
    dispatch(tooltipDetails(detail));
    dispatch(shouldShowTooltip(true));
    setTimeout(function () {
      dispatch(shouldShowTooltip(false));
    }, TOOLTIP_DURATION);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [battlesStarted]);
  useEffect(function () {
    return function () {
      dispatch(shouldShowTooltip(false));
    };
  }, [dispatch]);
  useEffect(function () {
    return function () {
      if (!showClockIcon) setShowClockIcon(true);
    };
  }, [showClockIcon]);
  var hideClockIcon = function hideClockIcon() {
    if (showClockIcon) setShowClockIcon(false);
  };
  return {
    battlesAssets: battlesAssets,
    missionsAssets: missionsAssets,
    selectedTab: selectedTab,
    handleOnPress: handleOnPress,
    isOnMissions: isOnMissions,
    isOnBattles: isOnBattles,
    hideClockIcon: hideClockIcon,
    showClockIcon: showClockIcon
  };
};
export default useMissionsTabs;